<mat-expansion-panel [expanded]="true" showToggle="false" class="matExpansion-selected">
  <mat-expansion-panel-header class="disable_ripple">
    <mat-panel-title>
      <!-- <b [ngStyle]="{color: this.frmSecondary.errors?.['required'] ? 'red': ''}"> SECONDARY (CURRENTLY ENROLLED IN GRADES 9-12, AD) : ACADEMIC REVIEW </b> -->

      <div *ngIf="this.frmSecondary.errors?.['required']==null">
        <b>SECONDARY (CURRENTLY ENROLLED IN GRADES 9-12, AD) : ACADEMIC REVIEW </b>
		<help-text-btn class="align-help-text-btn" [helpTextId]="'InaIlp_Secondary_Overview'"></help-text-btn>
      </div>
      <div *ngIf="this.frmSecondary.errors?.['required']">
        <b style="color: red;">SECONDARY (CURRENTLY ENROLLED IN GRADES 9-12, AD) : ACADEMIC REVIEW (incomplete)</b>
      </div>
    </mat-panel-title>
  </mat-expansion-panel-header>

  <form [formGroup]="frmSecondary">
    <div class="row">

      <div class="col-xs-12 col-sm-12 col-md-12 col-lg-9 col-xl-9">
        <!--Language Art, Math , ELPAC-->
        <div class="row" style="padding-top: 10px">
          <div class="col">
            <mat-label><b>Language Arts</b>
				<help-text-btn class="align-help-text-btn" [helpTextId]="'InaIlp_Secondary_LanguageArts'"></help-text-btn>
			</mat-label>
          </div>
          <div class="col">
            <mat-label><b>Math</b>
				<help-text-btn class="align-help-text-btn" [helpTextId]="'InaIlp_Secondary_Math'"></help-text-btn>
			</mat-label>
          </div>
          <div class="col">
            <mat-label><b>ELPAC</b>
				<help-text-btn class="align-help-text-btn" [helpTextId]="'InaIlp_Secondary_ELPAC'"></help-text-btn>
			</mat-label>
          </div>
        </div>

        <!--Year-->
        <div class="row" style="padding-top: 10px">
          <div class="col">
            <mat-label>Year : {{this.lYear}}</mat-label>
          </div>
          <div class="col">
            <mat-label>Year : {{this.mYear}}</mat-label>
          </div>
          <div class="col">
            <mat-label>Year : {{this.eYear}}</mat-label>
          </div>
        </div>

        <!--Assessed Grade-->
        <div class="row" style="padding-top: 10px">
          <div class="col">
            <mat-label>Assessed Grade: {{this.lGrade}}</mat-label>
          </div>
          <div class="col">
            <mat-label>Assessed Grade: {{this.mGrade}}</mat-label>
          </div>
          <div class="col">
            <mat-label>Assessed Grade: {{this.eGrade}}</mat-label>
          </div>
        </div>

        <!--Standard Met or Exceeded Proficient-->
        <div class="row" style="padding-top: 10px">
          <div class="col-4">
            <div class="row">
              <div clas="col">
                <mat-label>Standard Met or Exceeded &NonBreakingSpace;</mat-label>
              </div>
              <mat-radio-group aria-label name="radioArtStandardMet" formControlName="radioArtStandardMet"
                id="radioArtStandardMet">
                <div class="col">
                  <mat-radio-button [color]="'primary'" class="example-radio-button" value="1">Yes</mat-radio-button>
                </div>
                <div class="col">
                  <mat-radio-button [color]="'primary'" class="example-radio-button" value="2">No</mat-radio-button>
                </div>
              </mat-radio-group>
            </div>
          </div>
          <div class="col-4">
            <div class="row">
              <div clas="col">
                <mat-label>Standard Met or Exceeded &NonBreakingSpace;</mat-label>
              </div>
              <mat-radio-group aria-label name="radioMathStandardMet" formControlName="radioMathStandardMet"
                id="radioMathStandardMet">
                <div class="col">
                  <mat-radio-button [color]="'primary'" class="example-radio-button" value="1">Yes</mat-radio-button>
                </div>
                <div class="col">
                  <mat-radio-button [color]="'primary'" class="example-radio-button" value="2">No</mat-radio-button>
                </div>
              </mat-radio-group>
            </div>
          </div>
          <div class="col-4">
            <mat-label>Proficient &NonBreakingSpace;</mat-label>
            <mat-radio-group aria-label name="radioProficient" formControlName="radioProficient" id="radioProficient">
              <div class="col">
                <mat-radio-button [color]="'primary'" class="example-radio-button" value="1">Yes</mat-radio-button>
              </div>
              <div class="col">
                <mat-radio-button [color]="'primary'" class="example-radio-button" value="2">No</mat-radio-button>
              </div>
            </mat-radio-group>
          </div>
        </div>
      </div>


      <div class="col-xs-12 col-sm-12 col-md-12 col-lg-3 col-xl-3">
        <div class="row" >
          <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
            <mat-label><b>Comments</b>
				<help-text-btn class="align-help-text-btn" [helpTextId]="'InaIlp_Secondary_AssessmentComments'"></help-text-btn>
			</mat-label>
          </div>
          <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
            <mat-form-field>
              <textarea  matInput cdkTextareaAutosize #autosize="cdkTextareaAutosize" cdkAutosizeMinRows="1"
                cdkAutosizeMaxRows="5"  formControlName="languageComments">
            </textarea>
            </mat-form-field>
          </div>
        </div>
      </div>
    </div>

    <div class="row" style="padding-top: 30px">
      <mat-divider></mat-divider>
    </div>

    <div class="row" style="padding-top: 30px">
      <div class="col-xs-12 col-sm-12 col-md-12 col-lg-2 col-xl-2">      
        <div class="row">
          <div class="col">
            <mat-label>
              <b [ngStyle]="{color: this.radioUnaddressedCreditDeficiency.errors?.['required'] ? 'red': ''}">
                Unaddressed Credit Deficiency? *
              </b>
			  <help-text-btn class="align-help-text-btn" [helpTextId]="'InaIlp_Secondary_UnaddressedCreditDeficiency'"></help-text-btn>
			</mat-label>
            <mat-radio-group aria-label name="radioUnaddressedCreditDeficiency"
              formControlName="radioUnaddressedCreditDeficiency" id="radioUnaddressedCreditDeficiency" required>
              <div class="col">
                <mat-radio-button [color]="'primary'" class="example-radio-button" value="1">Yes</mat-radio-button>
              </div>
              <div class="col">
                <mat-radio-button [color]="'primary'" class="example-radio-button" value="2">No</mat-radio-button>
              </div>
            </mat-radio-group>
          </div>
        </div>
      </div>
      <div class="col-xs-12 col-sm-12 col-md-12 col-lg-7 col-xl-7">     
        <div class="row">
          <mat-label>
            <div *ngIf="radioUnaddressedCreditDeficiency.value=='1' && this.lstMepService.length<=0">
              <span><b style="color:red">Recommended MEP Services</b>
				<help-text-btn class="align-help-text-btn" [helpTextId]="'InaIlp_Secondary_RecommendedMEPServices'"></help-text-btn>
			  </span>
            </div>
            <div *ngIf="!(radioUnaddressedCreditDeficiency.value=='1' && this.lstMepService.length<=0)">
              <span><b>Recommended MEP Services</b>
				<help-text-btn class="align-help-text-btn" [helpTextId]="'InaIlp_Secondary_RecommendedMEPServices'"></help-text-btn>
			  </span>
            </div>
          </mat-label>
        </div>
        <div class="row">
          <div *ngIf="this.action!=3">
            <app-table-edit-service [lookupService]="lookupMepService" [(serviceData)]="lstMepService"
              (panelOpenState)="pOpenState($event)"></app-table-edit-service>
          </div>
          <div style="margin-top: 10px;" *ngIf="
                this.panelOpenState == false &&
                this.lstMepService.length > 0
              ">
            <mat-chip-listbox #chipList>
              <mat-chip-option *ngFor="let serviceEvent of lstMepService" (removed)="remove(serviceEvent)">
                {{serviceEvent.SERVICE_CODE}} - {{ serviceEvent.SERVICE_NAME }}
                <button *ngIf="this.action!=3" matChipRemove><mat-icon>cancel</mat-icon></button>
              </mat-chip-option>
            </mat-chip-listbox>
          </div>
        </div>
      </div>
      <div class="col-xs-12 col-sm-12 col-md-12 col-lg-3 col-xl-3">      
        <div class="row">
          <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
            <mat-label><b>Comments</b>
				<help-text-btn class="align-help-text-btn" [helpTextId]="'InaIlp_Secondary_UnaddressedCreditDeficiencyComments'"></help-text-btn>
            </mat-label>
          </div>
          <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
            <mat-form-field>
               <textarea   matInput cdkTextareaAutosize #autosize="cdkTextareaAutosize" cdkAutosizeMinRows="1"
               cdkAutosizeMaxRows="5"  formControlName="unaddressedComments"></textarea>
            </mat-form-field>
          </div>
        </div>
      </div>
    </div>
  </form>

  <div style="padding-top: 30px" class="row" *ngIf="(action==2 || action==3) ">
    <mat-accordion>
      <mat-expansion-panel>
        <mat-expansion-panel-header>
          <mat-panel-title>
            Past Edit - {{this.trackHistories.inaHistory.length}}
          </mat-panel-title>
        </mat-expansion-panel-header>
        <div *ngIf="this.trackHistories.inaHistory.length>=1">
          <app-past-edit [section]="this.section"></app-past-edit>
        </div>
      </mat-expansion-panel>
    </mat-accordion>
  </div>
</mat-expansion-panel>